export default "__VITE_ASSET__f8ukZ5xw__"